import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      d: "M4 12a8 8 0 0 0 8 8m-8-8a8 8 0 0 1 8-8m-8 8H2m10 8a8 8 0 0 0 8-8m-8 8v2m8-10a8 8 0 0 0-8-8m8 8h2M12 4V2M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z"
    }, null, -1)
  ])))
}
export default { render: render }